import { render, staticRenderFns } from "./movedStudentList.vue?vue&type=template&id=75c1b89a&scoped=true"
import script from "./movedStudentList.vue?vue&type=script&lang=js"
export * from "./movedStudentList.vue?vue&type=script&lang=js"
import style0 from "./movedStudentList.vue?vue&type=style&index=0&id=75c1b89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1b89a",
  null
  
)

export default component.exports